import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { or } from 'macro-decorators';
let LandingPageController = (_dec = or('currentAdmin.isGlobalAdmin', 'currentAdmin.isBillingAdmin'), (_class = class LandingPageController extends Controller {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentAdmin", _descriptor, this);
    _initializerDefineProperty(this, "roombaMetrics", _descriptor2, this);
    _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
    _initializerDefineProperty(this, "featureFlags", _descriptor4, this);
    _initializerDefineProperty(this, "canStartTrial", _descriptor5, this);
    _defineProperty(this, "createSubscriptionTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.roombaMetrics.trackEvent('start_get_started_clicked');
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        yield this.subscriptions.createRoomsSubscriptionTask.perform();
      }
    }), {
      drop: true
    }, "createSubscriptionTask", null));
  }
  isWorkplaceFeatureEnabled() {
    return this.featureFlags.isEnabled('workplace-garaje-launch');
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentAdmin", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "roombaMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "featureFlags", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "canStartTrial", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { LandingPageController as default };